import { useStateValue } from './StateProvider';
import CheckoutProduct from './CheckoutProduct';
import './Checkout.css';
import Subtotal from './Subtotal';

function Checkout() {
  const [{ basket, user }] = useStateValue();

  return (
    <div className="checkout">
      {basket?.length === 0 ? (
        <div>
          <img
            className="checkout__ad"
            src="https://cdn.pixabay.com/photo/2018/07/10/22/26/ecommerce-3529837_1280.jpg"
            alt=""
          />
          <div>
            <h2>Your Shopping Basket is empty</h2>
            <p>
              You have no item in your basket. To buy one or more items, click
              "Add to basket" next to the item.
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className="checkout__subtitle_row">
            <img
              className="checkout__subtitle_img"
              src="https://cdn.pixabay.com/photo/2018/07/10/22/26/ecommerce-3529837_1280.jpg"
              alt=""
            />
            <div className="checkout__right">
              <h1>Subtotal</h1>
              <Subtotal />
            </div>
          </div>

          <div>
            <h3>Hello, {user?.email}</h3>
            <h2 className="checkout__title">Your Shopping Basket</h2>
            {/* List out all of the checkout products */}
            {basket.map((item) => {
              console.log(item);
              return (
                <CheckoutProduct
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  image={item.image}
                  price={item.price}
                  rating={item.rating}
                />
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export default Checkout;
